export default {
  GOOD: 'good',
  REALLY_BAD: 'really_bad',
  BAD: 'bad',
  NEUTRAL: 'neutral',
}